export const modalDefaultProps = {
    open: false,
    preventCloseOnOutsideClick: false,
    size: 'medium',
    maxHeight: '464px',
    maxWidth: '',
};
